import { isNil } from "lodash";
import { Fragment, useEffect, useState } from "react";
import { PortStatus } from "./PortStatus";

export const PortMap = () => {
  type serverSideContent = {
    ports: {
      port: string[];
      reason: string;
    }[];
  };
  const [content, setContent] = useState<serverSideContent>();
  useEffect(() => {
    fetch("./portMap.json").then(async (val) => {
      let content: serverSideContent = await val.json();
      setContent(content);
    });
  }, []);

  return (
    <div>
      {isNil(content) ? (
        <></>
      ) : (
        <div>
          <div>
            This is a list of ports that the server might use. (11/1/25 -- the server now checks for you!).
          </div>
          <ul>
            {content.ports.map((entry) => (
              <li>
                <span style={{width:"10rem", display:'inline-block'}}>{`${entry.port}`}</span>
                <span style={{width:"20rem", display:'inline-block'}}>{`${entry.reason}`}</span>
                [{entry.port.map(((port,idx) => <Fragment><PortStatus port={port}/><span>{idx !== entry.port.length - 1 ? "," : ""}</span></Fragment>))}]
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
